import React from "react";
import { Grid } from "@mui/material";

import SoftBox from "../../components/SoftBox";
import ProgressBar from "../../components/LeaderBoard/LiveLeaderboard/ProgressBar";
import Podium from "./Podium";

/**
 * Company View Row 3 — one card titled "Team leaderboard":
 *   left  = the live points leaderboard (reuses the same ProgressBar rows)
 *   right = a podium of the top 3 teams from that same list
 * Points are recomputed the SAME way LiveLeaderboard does (amt × pointScale /
 * pointValue) so the numbers match the live leaderboard exactly.
 */
const TeamLeaderboard = ({ topList = [], groupKpis = null, allKpis = null, isViewOnly = true }) => {
  const kpisArr = Array.isArray(groupKpis) ? groupKpis : null;
  const sharedKpiById = {};
  if (kpisArr) kpisArr.forEach((k) => { if (k && k._id) sharedKpiById[k._id] = k; });

  const scopedList = topList.map((user) => {
    let kpiById = sharedKpiById;
    if (!kpisArr && allKpis && allKpis[user.userId]) {
      kpiById = {};
      allKpis[user.userId].forEach((k) => { if (k && k._id) kpiById[k._id] = k; });
    }
    const validKpiIds = Object.keys(kpiById);
    const fs = { total: 0 };
    Object.keys(user.scores || {}).forEach((key) => {
      if (key === "total") return;
      if (!validKpiIds.includes(key)) return;
      const o = user.scores[key];
      const kpi = kpiById[key];
      const amt = Number(o?.amt) || 0;
      const ps = Number(kpi?.pointScale) || 0;
      const pv = Number(kpi?.pointValue) || 0;
      const ppa = pv > 0 ? ps / pv : ps;
      const rp = kpi ? amt * ppa : Number(o?.pts) || 0;
      fs[key] = { ...o, pts: rp };
    });
    fs.total = Object.keys(fs).filter((k) => k !== "total").reduce((sum, k) => sum + (fs[k]?.pts || 0), 0);
    return { ...user, scores: fs };
  });

  const sorted = [...scopedList].sort((a, b) => {
    if (a.isActive === false && b.isActive !== false) return 1;
    if (a.isActive !== false && b.isActive === false) return -1;
    return (b.scores?.total || 0) - (a.scores?.total || 0);
  });

  const top = sorted[0]?.scores?.total || 1;
  const top3 = sorted.slice(0, 3).map((u) => ({
    name: u.firstName ? `${u.firstName}${u.lastName ? ` ${u.lastName}` : ""}` : "Team",
    points: Math.round(u.scores?.total || 0),
    image: u.image,
  }));

  return (
    <SoftBox
      borderRadius="lg"
      sx={{ background: "#ffffff", border: "1px solid #EAECF0", p: "16px 20px 18px" }}
    >
      <span style={{ fontFamily: "DM Sans", fontSize: "18px", fontWeight: 600, letterSpacing: "-0.01em", color: "#0F172A", lineHeight: 1.2 }}>
        Team leaderboard
      </span>
      <Grid container sx={{ mt: "12px" }} alignItems="stretch">
        <Grid item mini={12} lg={6}>
          {sorted.map((u, i) => (
            <ProgressBar
              key={u.userId || u.firstName}
              position={i + 1}
              imgsrc={u.image}
              userFirstName={u.firstName}
              userLastName={u.lastName}
              userKpis={u.scores}
              groupKpis={groupKpis ?? (allKpis ? allKpis[u.userId] : null)}
              top={top}
              isPointsPercent={false}
              isViewOnly={isViewOnly}
              selectable={false}
              isYeti={u.isYeti}
              playerStatus={u.isActive}
            />
          ))}
        </Grid>
        <Grid item mini={12} lg={6}>
          <SoftBox
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              borderLeft: { lg: "1px solid #EEF1F5" },
              pl: { lg: "24px" },
              pt: { mini: "16px", lg: 0 },
            }}
          >
            {top3.length > 0 && <Podium top3={top3} />}
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox>
  );
};

export default TeamLeaderboard;
